<div #map [style.width]="width" [style.height]="height"
></div>
<ng-content select="app-map-toolbox"></ng-content>
